import { render, staticRenderFns } from "./confirmFeedback.vue?vue&type=template&id=6cc43968&scoped=true&"
import script from "./confirmFeedback.vue?vue&type=script&lang=ts&"
export * from "./confirmFeedback.vue?vue&type=script&lang=ts&"
import style0 from "./confirmFeedback.vue?vue&type=style&index=0&id=6cc43968&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc43968",
  null
  
)

export default component.exports